import { Tab, TabList, Tabs } from '@react-spectrum/s2';
import type { Key } from 'react-aria-components';

export type ContentTab = 'content' | 'inspiration';

interface ContentTabsHeaderProps {
	activeTab: ContentTab;
	onTabChange: (tab: ContentTab) => void;
}

const TABS: { id: ContentTab; label: string }[] = [
	{ id: 'content', label: 'Content' },
	{ id: 'inspiration', label: 'Inspiration' },
];

// Mirrors PeopleTabsHeader: same S2 Tabs, same heading treatment, same
// shrink-0 header band so only the panel below it scrolls. Unlike People the
// tabs here are local state rather than separate spaces — Content and
// Inspiration are two views of the same artifacts fetch, not two routes.
export const ContentTabsHeader = ({
	activeTab,
	onTabChange,
}: ContentTabsHeaderProps) => {
	const handleSelectionChange = (key: Key) => {
		const tab = key as ContentTab;
		if (tab !== activeTab) onTabChange(tab);
	};

	return (
		<div
			className="flex shrink-0 flex-col px-6 pt-4 pb-10"
			data-testid="content-tabs-header"
		>
			<div className="flex items-center justify-between pb-6">
				<h1 className="text-xl font-bold text-(--text-primary)">Content</h1>
			</div>
			<Tabs
				selectedKey={activeTab}
				onSelectionChange={handleSelectionChange}
				aria-label="Content"
			>
				<TabList>
					{TABS.map((tab) => (
						<Tab key={tab.id} id={tab.id}>
							{tab.label}
						</Tab>
					))}
				</TabList>
			</Tabs>
		</div>
	);
};
